// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__a8r0p","stripe":"Carousel_stripe__PibaT","slide":"Carousel_slide__iRw11"};